import { render } from "./PageInbox.vue?vue&type=template&id=40309c54&scoped=true"
import script from "./PageInbox.vue?vue&type=script&lang=js"
export * from "./PageInbox.vue?vue&type=script&lang=js"

import "./PageInbox.vue?vue&type=style&index=0&id=40309c54&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40309c54"]])

export default __exports__